import LogoSvg from 'assets/images/logo-diamond.svg'
import YodleeImg from 'assets/images/yodlee.png'
import { CeruleanButton } from 'components/Button'
import I18n from 'components/I18n'
import Arrow, { ArrowSide } from 'components/Icons/Arrow'
import BankLogo from 'components/Icons/Bank'
import messages from 'lang'
import React from 'react'
import styled from 'styled-components'
import { color } from 'utils/styledHelper'

import { Header, ModalTitle } from '../../styles'

const BCLogo = styled.img.attrs<{}>(() => ({
  src: LogoSvg
}))`
  box-sizing: content-box;
  background: ${color('primary')};
  padding: 4px;
  border-radius: 3rem;
  width: 2rem;
`

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: relative;
  margin: 0 2rem;

  > * {
    z-index: 1;
  }

  hr {
    position: absolute;
    border: 1px solid #0c6cf2;
    top: 50%;
    width: 65%;
    margin: 0;
    z-index: 0;
  }
`

const YodleeLogo = styled.img.attrs<{}>(() => ({
  src: YodleeImg
}))``

const LogoWrapper = styled.div`
  border: 2px solid ${color('light')};
  background: white;
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  padding: 0.5rem;
`

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2rem 0;

  h2 {
    font-weight: 600;
    font-size: 14px;
    line-height: 150%;
    color: ${color('title')};
    margin: 0;
  }
  p {
    font-weight: 500;
    font-size: 12px;
    line-height: 150%;
    color: ${color('body')};
    text-align: center;
    margin: 0.5rem 0;
  }
`

const Link = styled.a`
  color: ${color('blue600')};
  text-decoration: none;

  :hover {
    color: ${color('blue500')};
  }
`

const Subtitle = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: ${color('title')};
`

const Button = styled(CeruleanButton)`
  width: 100%;
`

type Props = {
  onBack: () => void
  onClick: () => void
}

const SplashSceen = ({ onBack, onClick }: Props) => (
  <>
    <Header>
      <Arrow onClick={onBack} side={ArrowSide.LEFT} />
      <ModalTitle>
        <I18n data={messages.yodlee_splash_title} />
      </ModalTitle>
    </Header>
    <Subtitle>
      <I18n data={messages.yodlee_splash_subtitle} />
    </Subtitle>
    <ImageContainer>
      <LogoWrapper>
        <BCLogo />
      </LogoWrapper>
      <YodleeLogo />
      <LogoWrapper>
        <BankLogo fill='black' size='32' />
      </LogoWrapper>
      <hr />
    </ImageContainer>
    <Body>
      <h2>
        <I18n data={messages.yodlee_splash_body_title} />
      </h2>
      <p>
        <I18n
          data={messages.yodlee_splash_body_subtitle}
          link={
            <Link
              href='https://www.yodlee.com/legal/yodlee-security'
              rel='noopener noreferrer'
              target='_blank'
            >
              <I18n data={messages.button_learn_more} />
            </Link>
          }
        />
      </p>
    </Body>
    <Button e2e='depositAddBankSplashScreenContinueButton' onClick={onClick}>
      <I18n data={messages.button_continue} />
    </Button>
  </>
)

export default SplashSceen
